import { componentName, ImageClass } from './ImageClass';

customElements.define(componentName, ImageClass);

export { ImageClass, componentName };
